import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px 24px 24px;

  h1 {
    font-weight: 700;
    font-size: 24px;
    color: #263238;
    margin-top: 12px;
  }

  p {
    color: #757575;
    font-size: 14px;
    font-weight: 300;
    margin: 4px 0 16px;
  }
`;